import { Box } from '@mui/material';
import Tape from 'components/tape/Tape';
import { CanvasComponentConfig } from 'types/canvas';
import { HiroTab } from 'config/hiro';
import { useTapeCanvasAtoms } from 'hooks/canvas/useTapeCanvasAtoms';
import { useTapeCanvasSync } from 'hooks/canvas/useTapeCanvasSync';

interface CanvasFlowDataProps {
  id: number;
  config: CanvasComponentConfig;
  onConfigChange: (patch: Partial<CanvasComponentConfig>) => void;
}

const CanvasFlowData = ({
  id,
  config,
  onConfigChange,
}: CanvasFlowDataProps) => {
  const atoms = useTapeCanvasAtoms(id);
  const { isHydrated } = useTapeCanvasSync(id, config, onConfigChange);

  if (!isHydrated) {
    return null;
  }

  return (
    <Box sx={{ height: '100%', width: '100%', overflow: 'hidden' }}>
      <Tape
        hiroView={HiroTab.FlowData}
        tnsFlowLiveState={atoms.tnsFlowLiveState}
        columnSortModel={atoms.columnSortModel}
        activeCustomFilterState={atoms.activeCustomFilterState}
        filterActiveTabState={atoms.filterActiveTabState}
        filterPanelProps={{
          openState: atoms.filterPanelOpenState,
          panelView: 'modal',
        }}
        newFilterItemsState={atoms.newFilterItemsState}
        savedFiltersState={atoms.savedFiltersState}
        columnVisibilityState={atoms.columnVisibilityState}
        columnOrderState={atoms.columnOrderState}
        columnSizingState={atoms.columnSizingState}
        contractsColumnVisibilityState={atoms.contractsColumnVisibilityState}
        contractsSortModelState={atoms.contractsSortModelState}
        contractsColumnOrderState={atoms.contractsColumnOrderState}
        contractsColumnSizingState={atoms.contractsColumnSizingState}
        activeWatchlistIdsState={atoms.activeWatchlistIdsState}
      />
    </Box>
  );
};

export default CanvasFlowData;
